import { Badge, EmptyState } from '../../components/ui';
import { formatFechaMedia } from '../../utils/fechas';
import './Buscar.css';

export default function ListaFechas({ fechas, onElegir }) {
  if (fechas.length === 0) {
    return <EmptyState title="No hay turnos disponibles para este criterio." />;
  }

  return (
    <div className="buscar-dates" role="radiogroup" aria-label="Fechas disponibles">
      {fechas.map((f, i) => (
        <button key={f.clave} type="button" className="buscar-date-card" onClick={() => onElegir(f.clave)}>
          {i === 0 && <Badge tone="accent">Más próximo</Badge>}
          <span className="buscar-date-strong">{formatFechaMedia(f.fecha)}</span>
          <span className="buscar-muted">{f.cantidad} turno{f.cantidad === 1 ? '' : 's'}</span>
        </button>
      ))}
    </div>
  );
}